__turbopack_context__.v({
  "navMenuButton": "NavMenuButton-module__MIO6iG__navMenuButton",
});
